<div class="common-text-input__container"
  [id]="field.id">
  <div class="common-text-input__container-box"
    [ngClass]="{'common-text-input__container-box--error': field.error}"
    [attr.disabled]="field.noEditable?true:null">
    <div class="common-text-input__block-header">
      <label class="common-text-input__label"
        [for]="'field-type-text-'+field.id">
        <span class="common-text-input__text-label">{{fieldTypeText.titleField}}</span>
        @if(field.required){
          <span class="common-tag__mandatory-text-asterisk">*</span>
        }
        @if(field.specialIcon){
          <i [class]="field.specialIcon + ' common-icon__md-code-color-neutral-grey-800'"></i>
        }
        <div class="common-text-input__block-buttons">
          @if (field.description) {
            <tooltip-info [description]="field.description"
            [field]="field"></tooltip-info>
          }
          @if (field.references?.length) {
            <tooltip-law [references]="field.references"
            [field]="field"></tooltip-law>
          }
          @if (field.relatedInfo?.length) {
            <button class="common-button__icon-sm-noborder"
              pTooltip="{{'common.related-info'| afTranslate}}"
              tooltipPosition="top"
              (click)="openModalRelatedInfo(field.relatedInfo, $event)">
              <i class="lf-icon-search-text common-icon__md"></i>
            </button>
          }
          @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
            <tooltip-in-report [inReport]="fieldTypeText.inReport"></tooltip-in-report>
          }
        </div>
      </label>
      <div class="common-text-input__buttons-right-header">
        @if(field.ia && !field.isVoiceRecord && !isLanding && (permissions === 'admin' || permissions === 'manage')){
          <button class="common-button__icon-sm-noborder"
            [ngClass]="{'common-button__icon-sm-noborder--disabled':field.noEditable}"
            [disabled]="field.noEditable"
            (click)="openIaAssistance()">
            <i class="lf-icon-ia-line common-icon__md common-icon__highlight"></i>
          </button>
        }
        @if(field.evaluatedValue?.hasReferences){
          <button class="common-button__link landing-page__desktop"
            (click)="showReference($event)">
            <span class="common-button__link-text"
              [afTranslate]="fieldTypeText.showReferences?'common.hide-dependencies':'common.see-dependencies'"></span>
          </button>
        }
      </div>
    </div>
    <div class="common-text-input__block-input"
      [ngClass]="{'common-text-input__block-input--with-value': fieldTypeText.inputText && !field.noEditable}">
      <input class="common-text-input__input"
        type="text"
        autocomplete="off"
        [id]="'field-type-text-'+field.id"
        [name]="'field-type-text-'+field.id"
        [maxlength]="field.maxLength?field.maxLength:null"
        [placeholder]="field.noEditable?'':placeholder"
        [disabled]="field.noEditable"
        [(ngModel)]="fieldTypeText.inputText"
        (blur)="changeInField()"
        (keyup.enter)="enterChangeInField($event)"/>
      @if (fieldTypeText.inputText) {
        <button class="common-text-input__icon-clean-input"
          (click)="resetInput()">
          <i class="lf-icon-close-thick common-icon__sm"></i>
        </button>
      }
    </div>
    @if(field.evaluatedValue?.hasReferences){
      <div class="common-text-input__block-text-references landing-page__tablet">
        <button class="common-button__link"
          (click)="showReference($event)">
          <span class="common-button__link-text"
            [afTranslate]="fieldTypeText.showReferences?'common.hide-dependencies':'common.see-dependencies'"></span>
        </button>
      </div>
    }
    @if (fieldTypeText.showReferences && field.evaluatedValue.conceptDataId !== null && field.evaluatedValue.hasReferences) {
      <field-references
        [field]="field">
      </field-references>
    }
  </div>
  @if(field.error){
    <div class="common-text-input__mandatory-tag">
      @if(field.blocker){
        <i class="lf-icon-warning common-icon__error-md"></i>
      }
      @if (field.errorText) {
        <span>{{field.errorText}}</span>
      }@else {
        <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
      }
    </div>
  }
</div>
